import { Popover } from "@digdir/designsystemet-react";
import { InformationSquareIcon } from "@navikt/aksel-icons";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

type HelpTextProps = {
  feltKey: string;
  hjelpeTekstLabelTranslationKey: string;
  enabled: boolean;
};

export const HelpText = ({
  feltKey,
  hjelpeTekstLabelTranslationKey,
  children,
  enabled = true,
}: PropsWithChildren<HelpTextProps>) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-2">
      {children}
      {enabled && (
        <Popover.TriggerContext>
          <Popover.Trigger
            inline
            aria-label={t("button.vis-forklaring", { felt: feltKey })}
            className="inline-flex"
          >
            <InformationSquareIcon fontSize="1.5rem" />
          </Popover.Trigger>
          <Popover>
            <span className="font-normal">
              {t(hjelpeTekstLabelTranslationKey, { context: feltKey })}
            </span>
          </Popover>
        </Popover.TriggerContext>
      )}
    </div>
  );
};
